import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../../auth/AuthContext';
import { useGetDta } from '../../../hooks/useGetDta';
import { headTbl } from '../../../data/tables';
import LoadinSpin from '../../ui/LoadinSpin';
import classNames from 'classnames';
import Confirmation from '../../ui/Confirmation';
import Table from '../../Table';
import ModCargo from './ModCargo';
import { GiTakeMyMoney } from 'react-icons/gi';
import ModPayCargo from './ModPayCargo';
import { checkAccess } from '../../../helpers/details';

const CargosUs = ({ activo, activeTab }) => {
    const { id } = useParams();
    let idR = atob(id);
    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Facturación', auth.accesos);
       const {
           
           fact_agregar_cargo,
           fact_editar_cargo,
           fact_eliminar_cargo,
           fact_cobrar_cargo,
        } = permisos.functions

    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [item, setItem] = useState();
    const [car, setCar] = useState({});
    const [showC, setshowC] = useState(false);

    const [info, setInfo] = useState({});
    const { loading, data, getInfo } = useGetDta(`usertools/cargos/${idR}`);

    const openEdit = (ol) => {
        setItem(ol);
        setShow(true);
    };
    useEffect(() => {
        getInfo(`usertools/cargos/${idR}`);
    }, [activeTab, activo, idR]);
    const changeCob = (ca) => {
        setCar(ca);
        setshowC(true);
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                {!row.original.state && fact_cobrar_cargo && (
                    <OverlayTrigger
                        className="action-icon "
                        placement="left"
                        overlay={<Tooltip id="overlay-example">Cobrar</Tooltip>}>
                        <i>
                            <GiTakeMyMoney onClick={() => changeCob(row.original)} className="text-lg mx-1 " />
                        </i>
                    </OverlayTrigger>
                )}
                {fact_editar_cargo && !row.original.state && (
                    <OverlayTrigger
                        className="action-icon "
                        placement="left"
                        overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                        <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(row.original)}></i>
                    </OverlayTrigger>
                )}

                {fact_eliminar_cargo && (
                    <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                        <i className="mdi mdi-delete mdi-18px mx-2 " onClick={() => dele(row.original.id)}></i>
                    </OverlayTrigger>
                )}
            </>
        );
    };
    const dele = (id) => {
        setInfo({ id, type: 'CARGO' });
        setShowd(true);
    };
    const StatusColm = ({ row }) => {
        return (
            <span
                className={classNames('badge', {
                    'bg-success': row.original.state === 1,
                    'bg-danger': row.original.state === 0,
                })}>
                {row.original.state ? ' COBRADO' : '  POR COBRAR'}
            </span>
        );
    };
    const TipoColumn = ({ row }) => {
        return (
            <>
                <span className="text-center">${row.original.cargo}</span>
            </>
        );
    };
    const Column = ({ row }) => {
        return (
            <>
                <span className="text-center">{row.original.fact_dest}</span>
            </>
        );
    };
    const columns = [
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Monto',
            accessor: 'cargo',
            sort: true,
            Cell: TipoColumn,
        },
        {
            Header: 'Pago origen',
            accessor: 'fac_origen',
            sort: true,
        },

        {
            Header: 'Pago destino',
            accessor: 'fect_dest',
            sort: true,
            Cell: Column,
        },

        {
            Header: 'Descripción',
            accessor: 'nota',
            sort: true,
        },
        {
            Header: 'Estado',
            accessor: 'state',
            sort: true,
            Cell: StatusColm,
        },
        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="mt-3">
            {' '}
            <Row className="mb-2">
                <Col xs="auto">
                    {fact_agregar_cargo && (
                        <Button type="button" onClick={() => openEdit({})}>
                            <b>+</b> Nuevo
                        </Button>
                    )}
                </Col>
            </Row>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
            />
            <ModPayCargo show={showC} onClose={() => setshowC(false)} data={car} callBk={getInfo} />
            <ModCargo show={show} onClose={() => setShow(!show)} callBk={getInfo} item={item} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};

export default CargosUs;
